<app-modal
  class="density-lower"
  title="Visualização da imagem selecionada"
  [buttons]="false"
>
  <div class="modal-content">
    <img [src]="url" />
  </div>
</app-modal>
